import { init, addMessages, getLocaleFromNavigator } from 'svelte-i18n';
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
addMessages('en', en);
addMessages('de', de);
addMessages('fr', fr);
addMessages('it', it);
init({
    fallbackLocale: "de",
    initialLocale: getLocaleFromNavigator(),
});
